import React, {useEffect, useRef} from "react";
import Modal from "antd/es/modal";
import actions from "../../../../redux/company/actions";
import {useDispatch, useSelector} from "react-redux";
import {ButtonUser} from "../../../Useful/Button/ButtonUser";
import "./ModalCvStyle.scss"
const {getCvSourceDetailUser, clearCv} = actions

function ModalCV(props) {
    let {open, onOk, onCancel, cv} = props
    let dispatch = useDispatch()
    const cvRef = useRef(null)

    const cvUser = useSelector(state => state.Company.cv)
    

    useEffect(()=>{
        if(cv !== null && cv !== cvRef.current){
            dispatch(clearCv())
            cvRef.current = cv
            dispatch(getCvSourceDetailUser(cv))
        } else if(cv !== null && cvRef.current === null) {
            cvRef.current = cv
            dispatch(getCvSourceDetailUser(cv))
        }
    },[cv])

    useEffect(() => {
        return () => {
            dispatch(clearCv())
            cvRef.current = null
        }
    }, [])

    return(
        <Modal open={open} onOk={onOk} onCancel={onCancel} className={"modalCvCompany"}
               footer={[
                   <ButtonUser key="submit" type="primary" onClick={onOk}>
                       Chiudi
                   </ButtonUser>
               ]}
        >
            <div>
                {cvUser ? (
                    <object data={cvUser} type="application/pdf" width="100%" height="800px">
                        <embed src={cvUser} type="application/pdf" />
                    </object>
                ) : (
                    <div style={{textAlign: "center", padding: "40px"}}>
                        Caricamento CV in corso...
                    </div>
                )}
            </div>
        </Modal>
    )
}

export default ModalCV